import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { applyDocumentLanguage, localSettingsStore } from './settings/local';

applyDocumentLanguage(localSettingsStore.get().uiLanguage);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root missing');
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
